<script setup>
import { ref, useSlots } from 'vue';
import { PhxTabPanel, PhxTabs } from '@phx-styleguides/iwc';
import { get } from 'lodash-es';
import { PhxSpecsTable } from '@sg/src/View/Components/Molecules/SpecsTable';

defineProps({
  specs: {
    type: Object,
    required: true,
  },
});

const slots = useSlots();

const value = ref('overview');

const onChange = (newValue) => {
  value.value = newValue;
};

const shouldDisplayRow = (row) => {
  if (get(row, 'left') || get(row, 'right')) {
    return true;
  }

  if (get(row, 'slot')) {
    return !!slots[row.slot];
  }

  return false;
};

const getVisibleSpecs = (specValues) => {
  if (!Array.isArray(specValues)) {
    return [];
  }

  return specValues.filter(shouldDisplayRow);
};
</script>

<template>
  <phx-tabs
    class="product-spec tabs-group--with-indicator product-page-purchase__product-spec"
    layout="start"
    :indicator-thickness="1"
    :value="value"
    @change="onChange"
  >
    <phx-tab-panel v-for="spec in specs" :id="spec.id" :key="spec.id" :label="spec.label">
      <phx-specs-table :specs="getVisibleSpecs(spec.values)" hide-first-divider>
        <template v-for="(_, slotName) in slots" #[slotName]="slotProps">
          <slot :name="slotName" v-bind="slotProps" />
        </template>
      </phx-specs-table>
    </phx-tab-panel>
  </phx-tabs>
</template>
